/**
 * Wraps local storage interface, falling back to a local in-memory store if local storage is not available.
 */
export class LocalStorageWrapper {
  private inMemoryItems: Record<string, string> = {};

  setItem(key: string, value: string): void {
    this.inMemoryItems[key] = value;

    try {
      localStorage.setItem(key, value);
    } catch (error) {
      // noop, this is expected to fail in incognito mode
    }
  }

  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      // this is expected to fail in incognito mode
      return this.inMemoryItems[key] || null;
    }
  }

  removeItem(key: string): void {
    delete this.inMemoryItems[key];

    try {
      localStorage.removeItem(key);
    } catch (error) {
      // noop, this is expected to fail in incognito mode
    }
  }
}

export const localStorageWrapper = new LocalStorageWrapper();
